import React, { useRef } from "react";
import styled, { keyframes } from "styled-components";
import { Container, Eyebrow, Display, Lead, PrimaryButton, Arrow, useReveal } from "./ui";
import { colors, media } from "../../styles/theme";
import { cta, registerFor } from "../../pages/landingContent";
import icon from "../../assets/vimbal_icon_earth.svg";

const ripple = keyframes`
  from { transform: translate(-50%, -50%) scale(0.35); opacity: 0.7; }
  to { transform: translate(-50%, -50%) scale(1.25); opacity: 0; }
`;

const Wrap = styled.section`
  padding: 40px 0 120px;
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 36px;
  background:
    radial-gradient(70% 90% at 100% 0%, rgba(184, 115, 51, 0.45), transparent 60%),
    radial-gradient(60% 80% at 0% 100%, rgba(44, 88, 104, 0.55), transparent 60%),
    ${colors.forest};
  padding: 72px 28px;
  text-align: center;

  @media ${media.medium} {
    padding: 120px 64px;
  }
`;

const Rings = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;

  span {
    position: absolute;
    left: 0;
    top: 0;
    width: 1100px;
    height: 1100px;
    border-radius: 50%;
    border: 1px solid rgba(209, 154, 102, 0.35);
    animation: ${ripple} 9s linear infinite;
  }
  span:nth-child(2) {
    animation-delay: -3s;
  }
  span:nth-child(3) {
    animation-delay: -6s;
  }

  @media (prefers-reduced-motion: reduce) {
    span {
      animation: none;
      opacity: 0.25;
      transform: translate(-50%, -50%);
    }
  }
`;

const Inner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
`;

const Mark = styled.img`
  width: 64px;
  height: 64px;
  padding: 12px;
  border-radius: 20px;
  background: ${colors.linen};
  box-shadow: 0 20px 40px -20px rgba(0, 0, 0, 0.6);
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
`;

const Closing = ({ title = cta.title, emphasis = cta.titleEmphasis, body = cta.body, primary = cta.primary, interest }) => {
  const scope = useRef(null);
  useReveal(scope);
  return (
    <Wrap id="get-started" ref={scope} aria-labelledby="cta-title">
      <Container>
        <Card data-reveal>
          <Rings aria-hidden="true">
            <span />
            <span />
            <span />
          </Rings>
          <Inner>
            <Mark src={icon} alt="" />
            <Eyebrow $color={colors.copperLight} $onDark>
              {cta.eyebrow}
            </Eyebrow>
            <Display id="cta-title" $onDark style={{ maxWidth: 900 }}>
              {title} <em>{emphasis}</em>
            </Display>
            <Lead $onDark style={{ textAlign: "center" }}>
              {body}
            </Lead>
            <Actions>
              <PrimaryButton to={registerFor(interest)}>
                {primary} <Arrow />
              </PrimaryButton>
            </Actions>
          </Inner>
        </Card>
      </Container>
    </Wrap>
  );
};

export default Closing;
